/*
 * Roles that administer everything else, and are therefore protected in the UI:
 * their permissions cannot be opened or edited, and they cannot be deleted.
 *
 * Admin already holds every permission and Super Admin holds all but one, so
 * there is nothing meaningful to configure on either — but plenty to break,
 * since locking yourself out of these roles is unrecoverable from the UI.
 * Admin still appears in the Role Management list with just its actions
 * withheld; Super Admin goes further — see isHiddenRole below.
 *
 * Matched by NAME deliberately. The backend's is_system flag would be the
 * tidier lever, but it is FALSE for every seeded role today and flipping it
 * would also close these roles off at the API level for every tenant. This is
 * a presentation rule, so it lives here. Names must match the seeded role
 * names (see the c4e0a5b2d3f8 default-roles migration) and the JWT `role`
 * claim exactly.
 */
export const PROTECTED_ROLE_NAMES = ["Super Admin", "Admin"];

export const isProtectedRole = (roleName) =>
  PROTECTED_ROLE_NAMES.includes((roleName || "").trim());

/*
 * Super Admin specifically is withheld everywhere a role can be picked or
 * listed — the Role Management table, the "reporting to" and role-assignment
 * dropdowns on Add/Edit Employee, and the "roles this role can assign"
 * picker on Role Permissions — not just blocked from being edited/deleted
 * like the rest of PROTECTED_ROLE_NAMES. It is the tenant's own bootstrap
 * account; there is no scenario where handing it out or reporting to it
 * through these screens is the right move.
 */
export const HIDDEN_ROLE_NAMES = ["Super Admin"];

export const isHiddenRole = (roleName) =>
  HIDDEN_ROLE_NAMES.includes((roleName || "").trim());
